import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

export default function useQuery<T>(): T {
  const { search } = useLocation();
  return useMemo(() => {
    const withoutPrefix = search.startsWith('?') ? search.slice(1) : search;
    return queryString.parse(withoutPrefix || '') as unknown as T;
  }, [search]);
}
